import { motion } from "framer-motion";
import { Play } from "lucide-react";

export function Reveal({ children, delay = 0, as = "div", className, ...rest }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </M>
  );
}

export function LiveBadge({ label = "EN DIRECT" }) {
  return (
    <span className="live-badge"><span className="dot" /> {label}</span>
  );
}

export function Waveform({ bars = 9, color }) {
  return (
    <div className="waveform" style={color ? { color } : undefined} aria-hidden="true">
      {Array.from({ length: bars }).map((_, i) => (
        <span key={i} style={{ animationDelay: `${(i % 5) * 0.12}s` }} />
      ))}
    </div>
  );
}

export function VideoCard({ img, cap, tag, avatar, live, stats = [], className = "", style }) {
  return (
    <div className={`vcard ${className}`} style={style} data-testid="video-card">
      <img src={img} alt={cap} loading="lazy" />
      <div className="vcard__overlay" />
      <div className="vcard__top">
        {live ? <LiveBadge /> : <span className="vcard__tag">{avatar && <img src={avatar} alt="" />}{tag}</span>}
        <span className="vcard__play" style={{ position: "static", width: 34, height: 34, transform: "none" }}><Play size={15} fill="currentColor" /></span>
      </div>
      <div className="vcard__bottom">
        <div className="vcard__cap">{cap}</div>
        <Waveform bars={10} color="#fff" />
        <div className="vcard__stats" style={{ marginTop: 8 }}>
          {stats.map((s) => <span key={s}>{s}</span>)}
        </div>
      </div>
    </div>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__row">
        {row.map((it, i) => (
          <span key={i}>{it} <span style={{ color: "var(--brand-pink)" }}>·</span></span>
        ))}
      </div>
    </div>
  );
}
